module.exports = __webpack_public_path__ + "img/socials_vk.f9f7274f.svg";